export default function StepsRenderer({ section }){

    return(

        <ol>

            {(section.value || []).map((step,index)=>(

                <li key={index}>{step}</li>

            ))}

        </ol>

    );

}